/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  FleetRsiVerification,
  SchemaValidationErrorResponse,
  StandardError,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Generate a new RSI verification token
 */
export const createFleetRsiVerification = (
    fleetSlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);

      return axiosClient<FleetRsiVerification>(
      {url: `/fleets/${fleetSlug}/rsi-verification`, method: 'POST', signal
    },
      );
    }




export const getCreateFleetRsiVerificationMutationKey = () => ['createFleetRsiVerification'] as const;

export const getCreateFleetRsiVerificationMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetRsiVerification>>, TError,CreateFleetRsiVerificationMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createFleetRsiVerification>>, TError,CreateFleetRsiVerificationMutationVariables, TContext> => {

const mutationKey = getCreateFleetRsiVerificationMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFleetRsiVerification>>, CreateFleetRsiVerificationMutationVariables> = (props) => {
          const {fleetSlug} = props ?? {};

          return  createFleetRsiVerification(fleetSlug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFleetRsiVerificationMutationResult = NonNullable<Awaited<ReturnType<typeof createFleetRsiVerification>>>

    export type CreateFleetRsiVerificationMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type CreateFleetRsiVerificationMutationVariables = {fleetSlug: string}

    /**
 * @summary Generate a new RSI verification token
 */
export const useCreateFleetRsiVerification = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetRsiVerification>>, TError,CreateFleetRsiVerificationMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createFleetRsiVerification>>,
        TError,
        CreateFleetRsiVerificationMutationVariables,
        TContext
      > => {
      return useMutation(getCreateFleetRsiVerificationMutationOptions(options), queryClient);
    }
    /**
 * @summary Remove the fleet's RSI organisation verification
 */
export const destroyFleetRsiVerification = (
    fleetSlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);

      return axiosClient<FleetRsiVerification>(
      {url: `/fleets/${fleetSlug}/rsi-verification`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyFleetRsiVerificationMutationKey = () => ['destroyFleetRsiVerification'] as const;

export const getDestroyFleetRsiVerificationMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleetRsiVerification>>, TError,DestroyFleetRsiVerificationMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyFleetRsiVerification>>, TError,DestroyFleetRsiVerificationMutationVariables, TContext> => {

const mutationKey = getDestroyFleetRsiVerificationMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyFleetRsiVerification>>, DestroyFleetRsiVerificationMutationVariables> = (props) => {
          const {fleetSlug} = props ?? {};

          return  destroyFleetRsiVerification(fleetSlug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyFleetRsiVerificationMutationResult = NonNullable<Awaited<ReturnType<typeof destroyFleetRsiVerification>>>

    export type DestroyFleetRsiVerificationMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyFleetRsiVerificationMutationVariables = {fleetSlug: string}

    /**
 * @summary Remove the fleet's RSI organisation verification
 */
export const useDestroyFleetRsiVerification = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleetRsiVerification>>, TError,DestroyFleetRsiVerificationMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyFleetRsiVerification>>,
        TError,
        DestroyFleetRsiVerificationMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyFleetRsiVerificationMutationOptions(options), queryClient);
    }
    /**
 * @summary Show the fleet's RSI verification
 */
export const fleetRsiVerification = (
    fleetSlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);

      return axiosClient<FleetRsiVerification>(
      {url: `/fleets/${fleetSlug}/rsi-verification`, method: 'GET', signal
    },
      );
    }




export const getFleetRsiVerificationQueryKey = (fleetSlug: MaybeRefOrGetter<string>,) => {
    return [
    'fleets',fleetSlug,'rsi-verification'
    ] as const;
    }


export const getFleetRsiVerificationQueryOptions = <TData = Awaited<ReturnType<typeof fleetRsiVerification>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetRsiVerification>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetRsiVerificationQueryKey(fleetSlug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetRsiVerification>>> = ({ signal }) => fleetRsiVerification(fleetSlug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetRsiVerification>>, TError, TData>
}

export type FleetRsiVerificationQueryResult = NonNullable<Awaited<ReturnType<typeof fleetRsiVerification>>>
export type FleetRsiVerificationQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Show the fleet's RSI verification
 */

export function useFleetRsiVerification<TData = Awaited<ReturnType<typeof fleetRsiVerification>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetRsiVerification>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetRsiVerificationQueryOptions(fleetSlug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Check the RSI org page for the verification token
 */
export const checkFleetRsiVerification = (
    fleetSlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);

      return axiosClient<FleetRsiVerification>(
      {url: `/fleets/${fleetSlug}/rsi-verification/check`, method: 'POST', signal
    },
      );
    }




export const getCheckFleetRsiVerificationMutationKey = () => ['checkFleetRsiVerification'] as const;

export const getCheckFleetRsiVerificationMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkFleetRsiVerification>>, TError,CheckFleetRsiVerificationMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof checkFleetRsiVerification>>, TError,CheckFleetRsiVerificationMutationVariables, TContext> => {

const mutationKey = getCheckFleetRsiVerificationMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkFleetRsiVerification>>, CheckFleetRsiVerificationMutationVariables> = (props) => {
          const {fleetSlug} = props ?? {};

          return  checkFleetRsiVerification(fleetSlug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CheckFleetRsiVerificationMutationResult = NonNullable<Awaited<ReturnType<typeof checkFleetRsiVerification>>>

    export type CheckFleetRsiVerificationMutationError = ErrorType<ValidationError | StandardError>
    export type CheckFleetRsiVerificationMutationVariables = {fleetSlug: string}

    /**
 * @summary Check the RSI org page for the verification token
 */
export const useCheckFleetRsiVerification = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkFleetRsiVerification>>, TError,CheckFleetRsiVerificationMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof checkFleetRsiVerification>>,
        TError,
        CheckFleetRsiVerificationMutationVariables,
        TContext
      > => {
      return useMutation(getCheckFleetRsiVerificationMutationOptions(options), queryClient);
    }
